import React from "react";
import { Modal } from "react-bootstrap";
import SSOLoginForm from "./SSOLoginForm.jsx";
import dark from "!less-vars-loader!../../Asset/css/lessvars/colors-dark.less";
import LocalizationStore from "../../Stores/Localization/LocalizationStore";
import LangType from "../../Constants/LangType";
import AdobeUtil from "../../Utils/AdobeUtil";
import AdobeConstants from "../../Constants/AdobeConstants";
import consoleStore from "../../Stores/ConsoleWindow/ConsoleStore.js";
import LoginActions from "../../Actions/LoginActions.js";
import queryString from 'query-string';
import LoginStore from "../../Stores/Login/LoginStore.js";
const history = require("history").createHashHistory();

export default class SSOLogin extends React.Component {
  constructor(props){
    super(props);

    let lang = LangType.RAY_DEFAULT;
    let prefix = "cn.";
    let suffix = ".cn";
    let hostname = window.location.hostname;
    hostname = hostname.toLowerCase();
    let showLicense = false;
    let location = props.location;
    if(hostname.startsWith(prefix) || hostname.endsWith(suffix)){
          lang = LangType.ZH_CN;
          showLicense = true;
    } else {
      let temp = navigator.language || navigator.browserLanguage;
      if(temp !== null && temp != ""){
        switch (temp.toLowerCase()){
          case "zh-cn":
            lang = LangType.ZH_CN;
            break;
          default:
            lang = LangType.RAY_DEFAULT;
            break;
        }
      }
    }
    this.state={
      lang: lang,
      showLicense: showLicense,
      updateState: false
    }

    LocalizationStore.setLang(lang);
  }

  getBgClass() {
    let result = "login-bg-default";

    switch(this.state.lang){
      case LangType.ZH_CN:
        result = "login-bg-zh-cn";
        break;
      case LangType.RAY_DEFAULT:
        result = "login-bg-default";
        break;
      default:
        result = "login-bg-default";
        break;
    }

    return result;
  }

  UNSAFE_componentWillMount() {
    document.body.style.backgroundColor = dark.applicationBody;
    //Push data to DTM while loading login page

    if(this.props.location && this.props.location.search){
      const parsed = queryString.parse(this.props.location.search);
      if(parsed && parsed.company){
        LoginActions.getUserStatusInfo(null, parsed.company); 
      }
    }

    AdobeUtil.DTMTrack({
      pageName: "Panaray : Login",
      siteSection: "Login",
      userType: "Visitor"
    },
     AdobeConstants.LOGIN_PAGE_VIEW);
  }

  UNSAFE_componentWillReceiveProps(props) {
    if(props.location && props.location.search){
      const parsed = queryString.parse(props.location.search);
      if(parsed && parsed.company){
        LoginActions.getUserStatusInfo(null, parsed.company); 
      }
      else if(parsed && parsed.ErrMessage){
        LoginStore.closeWindow();
        LoginStore.onSSOUserLoginFailed(parsed.ErrMessage);
        history.push('/SSO');
      }
    } 
}

  componentWillUnmount() {
    document.body.style.backgroundColor = '';
    consoleStore.removeSessionExpiredPopup();
  }

  closeSessionExpirePopup = () =>{
    consoleStore.removeSessionExpiredPopup();
    this.setState({updateState:true});
  }

  render() {
    const reDirectStatus = (this.props.location.state && this.props.location.state.from === "/") ? true : false;
    const displaySessionExpirePopup = (consoleStore.getSessionExpiredPopupStatus() === "true") && reDirectStatus;

    return (
      <div className={this.getBgClass()}>
        <div className="loginWrap">
          <SSOLoginForm />
        </div>
        {this.state.showLicense ? <div className="license">{LocalizationStore.getTranslatedData("ICP", "")}</div> : ""}
        {displaySessionExpirePopup ? (<Modal className="modal-popup session-expired" show={displaySessionExpirePopup} backdrop="static">
          <Modal.Header><h4>Session Expired!</h4></Modal.Header>
          <Modal.Body>
            <div className="modal-material">
              <p>You have been logged out due to inactivity. Click "OK" to log in.</p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <span className="btn-box center">
              <button type="button" className="btn btn-xs btn-default btn-secondary" onClick={this.closeSessionExpirePopup}>OK</button>
            </span>
          </Modal.Footer>
        </Modal>) : ""}
      </div>
    );
  }
}
